import * as z from 'zod'

import { CONTENTS_NXT_CONSTANTS } from '@flows/configs/contentsNxt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'
import { BaseSchema_ContentsPremiumBasicNeodigitalDe } from '@flows/insurance/schemas'

const claimsOptionsFromSchema = schemaUtils.getEnumValuesFromPipelineSchema(
  BaseSchema_ContentsPremiumBasicNeodigitalDe.shape.number_of_previous_claims
)

const contents_damages = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]:
        validators.createPreprocessedEnumNumberSchema(z.enum([...claimsOptionsFromSchema, '3'])),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_damages.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
        options: CONTENTS_NXT_CONSTANTS.claimsOptions,
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
      valueToStepName: {
        '0': 'contents_insurance_cancelled',
        '1': 'contents_insurance_cancelled',
        '2': 'contents_insurance_cancelled',
        '3': FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_damages
